import { Button, Col, Image, Row, Spin } from 'antd'
import Project350Banner from 'components/Project350/Banner/index'
import DefaultFooter from 'components/SuperCard/DefaultFooter'
import Header from 'components/SuperCard/Header'
import { Sliced } from 'components/SuperCard/UIElements'
import React from 'react'
import styled from 'styled-components'
import { IS_BONANZA_PROMO_ACTIVE } from 'utils/constants'
import ViewContainer from './container'

const Styled = styled.div`
  padding-bottom: 100px;

  .my-sc-container {
    border-radius: 10px;
  }

  .sc-question {
    cursor: pointer;
    position: absolute;
  }

  @media only screen and (max-width: 912px) {
    .sc-question {
      display: none !important;
    }
  }
`

export default function Index() {
  return (
    <>
      <ViewContainer>
        {({ data, isLoading, setIsLoading, redirectLink }) => (
          <Styled>
            <Header
              defaultKey="buy"
              setIsLoading={setIsLoading}
              showBonanzaBanner
            />
            <Spin spinning={isLoading}>
              <Row>
                {/* <Col span={1} className='sc-question' onClick={() => redirectLink('/supercard/faq')}> */}
                <Col span={1} className="sc-question">
                  <a
                    href="https://www.mysupercard.ph/"
                    rel="noreferrer"
                    target="_blank"
                  >
                    <Image
                      src="/images/supercard/sc-question-icon.png"
                      alt="Question"
                      width="58"
                      height="50"
                      preview={false}
                    />
                  </a>
                </Col>
                <Col
                  className="mt-5"
                  xs={{ span: 21, offset: 2 }}
                  sm={{ span: 21, offset: 2 }}
                  md={{ span: 9, offset: 1 }}
                  lg={{ span: 9, offset: 1 }}
                  xl={{ span: 9, offset: 1 }}
                >
                  <h1 style={{ color: 'var(--cognac)', lineHeight: '50px' }}>
                    A must-have card in every wallet!
                  </h1>
                  <p style={{ color: 'var(--black)' }}>
                    Purchase your own Supercard today for easy access to promos
                    and freebies.
                  </p>
                  <p className="subtitle" style={{ color: 'var(--grey)' }}>
                    If you've already created an account with your Supercard
                    number as Login, you may continue to access your account
                    here.
                  </p>
                  <Button
                    className="default-btn-size"
                    type="primary"
                    onClick={() => redirectLink('/supercard/validate')}
                  >
                    <p style={{ fontSize: '20px' }}>Register Supercard</p>
                  </Button>
                </Col>
                {IS_BONANZA_PROMO_ACTIVE && (
                  <Col xs={{ span: 24 }} md={{ span: 12 }} lg={{ span: 12 }}>
                    <Project350Banner />
                  </Col>
                )}
              </Row>

              <Row className="mt-5">
                <Col
                  xs={{ span: 20, offset: 2 }}
                  sm={{ span: 20, offset: 2 }}
                  md={{ span: 20, offset: 2 }}
                  lg={{ span: 22, offset: 1 }}
                  xl={{ span: 22, offset: 1 }}
                >
                  <Row gutter={[40, 24]}>
                    {data &&
                      data.map((detail, k) => (
                        <Col
                          key={k}
                          className="my-sc-container"
                          xs={{ span: 24, offset: 0 }}
                          sm={{ span: 24, offset: 0 }}
                          md={{ span: 24, offset: 0 }}
                          lg={{ span: 12, offset: 0 }}
                          xl={{ span: 12, offset: 0 }}
                        >
                          <Sliced
                            key={k}
                            details={detail}
                            redirectLink={redirectLink}
                          />
                        </Col>
                      ))}
                  </Row>
                </Col>
              </Row>
              <DefaultFooter redirectLink={redirectLink} />
            </Spin>
          </Styled>
        )}
      </ViewContainer>
    </>
  )
}
